const wizard = {
  status: {
    PENDING: 0,
    COMPLETED: 1,
    MINIMIZED: 2,
  },
}

export default wizard
